import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, ShoppingBag } from "lucide-react";
import { useCart } from "../context/CartContext";

const links = [
  { to: "/", label: "Home" },
  { to: "/how-it-works", label: "How Leasing Works" },
  { to: "/products", label: "iPhones" },
  { to: "/ipads", label: "iPads" },
  { to: "/macbooks", label: "MacBooks" },
  { to: "/conditions", label: "Condition Guide" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  const { count, setOpen: setCartOpen } = useCart();

  const CartButton = ({ testId }) => (
    <button
      onClick={() => setCartOpen(true)}
      data-testid={testId}
      aria-label="Open cart"
      className="relative flex h-10 w-10 items-center justify-center rounded-full text-ink transition-colors hover:text-crimson"
    >
      <ShoppingBag className="h-5 w-5" />
      {count > 0 && (
        <span data-testid="cart-count-badge" className="absolute -right-0.5 -top-0.5 flex h-5 min-w-[1.25rem] items-center justify-center rounded-full bg-crimson px-1 text-[11px] font-bold text-white">
          {count}
        </span>
      )}
    </button>
  );

  return (
    <header className="fixed top-0 z-50 w-full border-b border-line bg-white/70 backdrop-blur-xl">
      <nav className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 lg:px-12">
        <Link to="/" data-testid="nav-logo" className="flex items-center">
          <img src="/aap-logo.png" alt="Adopt-A-Phone — Your Smartphone Retailer" className="h-9 w-auto sm:h-10" />
        </Link>

        <div className="hidden items-center gap-6 lg:flex">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={`whitespace-nowrap text-sm font-medium transition-colors hover:text-crimson ${pathname === l.to ? "text-crimson" : "text-ink"}`}
            >
              {l.label}
            </Link>
          ))}
          <Link
            to="/apply"
            data-testid="nav-cta"
            className="whitespace-nowrap rounded-full bg-ink px-5 py-2.5 text-sm font-bold text-white transition-colors hover:bg-crimson"
          >
            Lease Now
          </Link>
          <CartButton testId="nav-cart-desktop" />
        </div>

        <div className="flex items-center gap-1 lg:hidden">
          <CartButton testId="nav-cart-mobile" />
          <button data-testid="nav-mobile-toggle" onClick={() => setOpen(!open)} aria-label="Menu">
            {open ? <X /> : <Menu />}
          </button>
        </div>
      </nav>

      {open && (
        <div className="border-t border-line bg-white px-6 py-4 lg:hidden" data-testid="nav-mobile-menu">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              onClick={() => setOpen(false)}
              className="block py-3 text-base font-medium text-ink"
            >
              {l.label}
            </Link>
          ))}
          <Link
            to="/apply"
            onClick={() => setOpen(false)}
            data-testid="nav-mobile-cta"
            className="mt-3 block rounded-full bg-ink px-5 py-3 text-center text-base font-bold text-white transition-colors hover:bg-crimson"
          >
            Lease Now
          </Link>
        </div>
      )}
    </header>
  );
}
